import React, { useState, useEffect } from "react";
import {
  FaEllipsisV,
  FaCheckCircle,
  FaUserSlash,
  FaUserShield,
  FaTrash,
  FaExclamationTriangle,
  FaSearch,
} from "react-icons/fa";
import Swal from "sweetalert2";
import "./UserManagement.css";
import AdminNavbar from "../AdminNavbar";
import axios from "axios";

const UserManagementX44 = () => {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [openDropdown, setOpenDropdown] = useState(null);
  const [filterStatus, setFilterStatus] = useState("all");
  const [genderFilter, setGenderFilter] = useState("all");

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await axios.get("https://back.varankal.com/user/users");
      setUsers(response.data);
    } catch (error) {
      console.error("Error fetching users:", error);
      Swal.fire("Error", "Could not fetch users. Please try again.", "error");
    }
  };
  const handleStatusChange = async (id, newStatus) => {
    try {
      let endpoint = "";

      if (newStatus === "Active") {
        endpoint = `https://back.varankal.com/user/${id}/activate`;
      } else if (newStatus === "Suspended") {
        endpoint = `https://back.varankal.com/user/${id}/suspend`;
      } else if (newStatus === "Pending") {
        endpoint = `https://back.varankal.com/user/${id}/pending`;
      }

      const response = await axios.put(endpoint);

      if (response.status === 200) {
        setUsers((prev) =>
          prev.map((user) =>
            user._id === id ? { ...user, status: newStatus } : user
          )
        );
        Swal.fire("Updated!", `User status changed to ${newStatus}.`, "success");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      Swal.fire("Error", "Could not update user status. Please try again.", "error");
    }
  };

  const handleCarryOver = async (id) => {
    try {
      const response = await axios.put(
        `https://back.varankal.com/api/payments/users/${id}/carry-over`,
        { carryOverEnabled: true }
      );

      if (response.status === 200) {
        Swal.fire("Success", "Carry Over completed successfully.", "success");
      }
    } catch (error) {
      console.error("Carry Over error:", error);
      Swal.fire("Error", "Failed to carry over. Please try again.", "error");
    }
  };

  const handleMakeAdmin = async (userId) => {
    try {
      const response = await fetch(`https://back.varankal.com/auth/make-admin/${userId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) throw new Error("Failed to promote user");

      await response.json();
      alert("User promoted to admin successfully");
      fetchUsers();
    } catch (error) {
      console.error(error);
      alert("Error making user admin");
    }
  };

  const handleDeleteUser = async (id) => {
    try {
      const response = await axios.delete(`https://back.varankal.com/user/${id}`);

      if (response.status === 200) {
        setUsers((prev) => prev.filter((user) => user._id !== id));
        Swal.fire("Deleted!", "User has been deleted.", "success");
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      Swal.fire("Error", "Could not delete user. Please try again.", "error");
    }
  };

  // Filtering logic
  const filteredUsers = users.filter((user) => {
    const matchesSearch =
      user.email?.toLowerCase().includes(search.toLowerCase()) ||
      user.basicDetails?.name?.toLowerCase().includes(search.toLowerCase());

    const matchesStatus = filterStatus === "all" || user.status === filterStatus;
    const matchesGender =
      genderFilter === "all" ||
      user.basicDetails?.gender?.toLowerCase() === genderFilter.toLowerCase();

    return matchesSearch && matchesStatus && matchesGender;
  });

  return (
    <>
      <AdminNavbar />
      <div className="user-managementX44">
        <h2 className="titleX44">User Management</h2>

        <div className="filtersX44">
          <div className="search-containerX44">
            <FaSearch className="search-iconX44" />
            <input
              type="text"
              placeholder="Search by Name or Email..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="search-inputX44"
            />
          </div>
          <select
            onChange={(e) => setFilterStatus(e.target.value)}
            value={filterStatus}
            className="selectX44"
          >
            <option value="all">All Status</option>
            <option value="Active">Active</option>
            <option value="Suspended">Suspended</option>
            <option value="Pending">Pending</option>
          </select>
          <select
            onChange={(e) => setGenderFilter(e.target.value)}
            value={genderFilter}
            className="selectX44"
          >
            <option value="all">All Genders</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </select>
        </div>

        <div className="user-tableX44">
          <table>
            <thead>
              <tr>
                <th>Profile</th>
                <th>Full Name</th>
                <th>Email</th>
                <th>Gender</th>
                <th>Date of Birth</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.map((user) => (
                <tr key={user._id}>
                  <td>
                    {user.basicDetails?.profilePicture ? (
                      <img
                        src={user.basicDetails.profilePicture}
                        alt="Profile"
                        style={{ width: 80, height: 80, borderRadius: "50%" }}
                      />
                    ) : (
                      <span>No Image</span>
                    )}
                  </td>
                  <td>{user.basicDetails?.name || "N/A"}</td>
                  <td>{user.email}</td>
                  <td>{user.basicDetails?.gender || "N/A"}</td>
                  <td>
                    {user.basicDetails?.dateOfBirth
                      ? new Date(user.basicDetails.dateOfBirth).toLocaleDateString()
                      : "N/A"}
                  </td>
                  <td>
                    <span className={`statusX44 ${user.status?.toLowerCase()}X44`}>
                      {user.status}
                    </span>
                  </td>
                  <td className="actionsX44">
                    <div className="dropdownX44">
                      <button
                        className="dropdown-btnX44"
                        onClick={() =>
                          setOpenDropdown(openDropdown === user._id ? null : user._id)
                        }
                      >
                        <FaEllipsisV />
                      </button>
                      {openDropdown === user._id && (
                        <div className="dropdown-menuX44">
                          {user.status !== "Active" && (
                            <button
                              onClick={() => handleStatusChange(user._id, "Active")}
                              className="dropdown-itemX44"
                            >
                              <FaCheckCircle /> Activate
                            </button>
                          )}
                          {user.status !== "Suspended" && (
                            <button
                              onClick={() => handleStatusChange(user._id, "Suspended")}
                              className="dropdown-itemX44"
                            >
                              <FaUserSlash /> Suspend
                            </button>
                          )}
                          {user.status !== "Pending" && (
                            <button
                              onClick={() => handleStatusChange(user._id, "Pending")}
                              className="dropdown-itemX44"
                            >
                              <FaExclamationTriangle /> Pending
                            </button>
                          )}
                          <button
                            onClick={() => handleCarryOver(user._id)}
                            className="dropdown-itemX44"
                          >
                            <FaCheckCircle /> Carry Over
                          </button>
                          <button
                            onClick={() => handleDeleteUser(user._id)}
                            className="dropdown-itemX44"
                          >
                            <FaTrash /> Delete
                          </button>
                          <button
                            onClick={() => handleMakeAdmin(user._id)}
                            className="dropdown-itemX44"
                          >
                            <FaUserShield />{" "}
                            {user.role === "admin" ? "Remove Admin" : "Make Admin"}
                          </button>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default UserManagementX44;
